define('viewmodels/pages/cash/cashTabs',['core/TabSet'], function (TabSet) {

    return function(navigation, getDepositField, getWithdrawField, getHistoryField) {

        return new TabSet(navigation, 'cash', [
            {
                routeConfig: {
                    route: navigation.ROUTES.DEPOSIT
                },
                title: getDepositField('tab_title'),
                icon: 'bill-plus'
            },
            {
                routeConfig: {
                    route: navigation.ROUTES.WITHDRAW
                },
                title: getWithdrawField('tab_title'),
                icon: 'bill-minus'
            },
            {
                routeConfig: {
                    route: navigation.ROUTES.HISTORY
                },
                title: getHistoryField('tab_title'),
                icon: 'bill-list'
            }
        ]);
    };
});

